/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pricing_Choose_PaymentInputs */

const en_common_pricing_choose_payment = /** @type {(inputs: Common_Pricing_Choose_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose payment method`)
};

const zh_common_pricing_choose_payment = /** @type {(inputs: Common_Pricing_Choose_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择支付方式`)
};

/**
* | output |
* | --- |
* | "Choose payment method" |
*
* @param {Common_Pricing_Choose_PaymentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pricing_choose_payment = /** @type {((inputs?: Common_Pricing_Choose_PaymentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pricing_Choose_PaymentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pricing_choose_payment(inputs)
	return zh_common_pricing_choose_payment(inputs)
});
export { common_pricing_choose_payment as "common.pricing.choose_payment" }